import { DrilldownNode } from "@/shared/model/drilldown-node";
import { DRILLDOWN_LEAGUE_LEVEL_NUMBER } from "@/shared/utils/constants";
import { Sport } from "@/shared/model/enums/sport";

const DrilldownNodeUtils = {
    isSportMultilevel(sportCode: Sport) {
        if (environment.config["multilevel-sports"]) {
            return environment.config["multilevel-sports"].includes(sportCode);
        } else {
            return sportCode === Sport.Esports || sportCode === Sport.Tennis || sportCode === Sport.MotorRacing;
        }
    },
    getCategoryName(drilldownNodes: DrilldownNode[], categoryId: string = "") {
        const drilldown = drilldownNodes?.find((d: DrilldownNode) =>
            categoryId ? d.id === categoryId : d.levelNumber === DRILLDOWN_LEAGUE_LEVEL_NUMBER,
        );
        if (drilldown?.code === Sport.Esports) {
            const parentId = drilldown?.parentDrilldownNodeId;
            return `${drilldown?.name}, ${drilldownNodes?.find((d: DrilldownNode) => d.id === parentId)?.name}`;
        }
        return drilldown?.name || "";
    },
    getSportName(drilldownNodes: DrilldownNode[], id: string) {
        const branchPath = this.buildBranchPath(drilldownNodes, id);
        const node = drilldownNodes.find((d) => d.id === branchPath?.[0]);
        return node?.name;
    },
    buildTree(
        items: object[],
        id: string | number | null = null,
        childrenKey = "drilldownNodes",
        idKey = "id",
        parentIdKey = "parentDrilldownNodeId",
    ) {
        return items
            .filter((item) => item[parentIdKey] === id)
            .map((item) => ({ ...item, [childrenKey]: this.buildTree(items, item[idKey]) }));
    },
    buildBranchPath(items: object[], id: string | number, idKey = "id", parentIdKey = "parentDrilldownNodeId") {
        const result: string[] = [];
        const traverse = (items, id) => {
            const node = items.find((item) => item[idKey] === id);
            const parent = items.find((item) => item[idKey] === node?.[parentIdKey]);
            if (node) {
                result.unshift(node[idKey]);
            }
            if (parent) {
                traverse(items, parent[idKey]);
            }
        };
        traverse(items, id);
        return result;
    },
};

export default DrilldownNodeUtils;
